import React from "react";
import "../assets/css/style.css";
import { Fade, Zoom } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import img1 from "../assets/image/img50.jpg";
import img2 from "../assets/image/img2.jpg";
import img3 from "../assets/image/img3.jpeg";
import img4 from "../assets/image/img51.jpg";
import img5 from "../assets/image/img52.jpg";
import img6 from "../assets/image/img6.jpeg";
import img7 from "../assets/image/img23.jpg";
import img8 from "../assets/image/img8.jpg";
import img10 from "../assets/image/img10.jpg";
import img11 from "../assets/image/img37.JPG";
import img12 from "../assets/image/img12.jpg";
import img13 from "../assets/image/img38.JPG";


const NotFound = () => {
  const breadcrumb = [
    { label: "Home", href: "/" },
    { label: "Gallery", href: "/portfolio", active: true }
  ];

  const gallery = [
  {
    id: 1,
    image: img1,
    title: "Modern Interior Layout",
    category: "Interior Design & Fit-Out"
  },
  {
    id: 2,
    image: img2,
    title: "Elegant Spatial Design",
    category: "Interior Design & Fit-Out"
  },
  {
    id: 3,
    image: img3,
    title: "Contemporary Space Planning",
    category: "Interior Design & Fit-Out"
  },
  {
    id: 4,
    image: img4,
    title: "Refined Interior Aesthetics",
    category: "Interior Design & Fit-Out"
  },
  {
    id: 5,
    image: img5,
    title: "Premium Designed Space",
    category: "Interior Design & Fit-Out"
  },
  {
    id: 6,
    image: img6,
    title: "Functional Interior Environment",
    category: "Interior Design & Fit-Out"
  },
  {
    id: 7,
    image: img7,
    title: "Well-Balanced Interior Design",
    category: "Interior Design & Fit-Out"
  },
  {
    id: 8,
    image: img8,
    title: "Thoughtfully Designed Interior",
    category: "Interior Design & Fit-Out"
  },
  {
    id: 10,
    image: img10,
    title: "Modern Living Environment",
    category: "Interior Design & Fit-Out"
  },
  {
    id: 11,
    image: img11,
    title: "Sophisticated Interior Styling",
    category: "Interior Design & Fit-Out"
  },
  {
    id: 12,
    image: img12,
    title: "Minimal & Clean Interior Space",
    category: "Interior Design & Fit-Out"
  },
  {
    id: 13,
    image: img13,
    title: "Professionally Designed Interior",
    category: "Interior Design & Fit-Out"
  }
];


  return (
    <>
      <PageHeader title="Interior Design Gallery" breadcrumb={breadcrumb} />

     <Fade triggerOnce>
  <div className="container-xxl py-6">
    <div className="container">

      {/* Section Header */}
      <div className="text-center mb-5">
        <p className="text-primarys text-uppercase mb-2 fw-bold tracking">
          ✦ Interior Gallery ✦
        </p>
        <h1 className="display-6 fw-bold">
          Where Design Meets Elegance
        </h1>
        <p className="text-muted mt-3">
          Discover thoughtfully crafted interiors that blend luxury, comfort, and innovation.
        </p>
      </div>

      {/* Gallery Grid */}
      <div className="row g-4">
        {gallery.map((item, index) => (
          <div key={item.id} className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <Zoom delay={index * 120} triggerOnce>
              <div className="gallery-card-advanced">

                {/* Image */}
                <div className="gallery-img-wrapper">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="img-fluid"
                  />

                  {/* Overlay */}
                  <div className="gallery-hover">
                    <span className="gallery-category">{item.category}</span>
                    <h5>{item.title}</h5>

                    
                  </div>
                </div>

              </div>
            </Zoom>
          </div>
        ))}
      </div>

    </div>
  </div>
</Fade>

    </>
  );
};

export default NotFound;


